// External libraries
import gql from 'graphql-tag';

export const CREATE_BANK_ACCOUNT_CANDIDATE_MUTATION = gql`
  mutation CreateBankAccountCandidateMutation(
    $bank: BankAccountInput!
    $beneficiary: BankAccountBeneficiaryInput
    $billingAddress: AddressInput
    $countryCode: CountryCodes!
  ) {
    addBankCandidate(
      bank: $bank
      beneficiary: $beneficiary
      billingAddress: $billingAddress
      countryCode: $countryCode
    ) {
      accountNumber
      accountNumberShort
      bankIdentifierCode
      beneficiaries {
        fullName
      }
      billingAddress {
        city
        fullAddress
      }
      creditor {
        address {
          fullAddress
        }
        id
        name
      }
      currencyCode
      id
      issuer {
        branchLocation
        city
        country
        name
      }
      nickname
      routingNumber
      type
    }
  }
`;
